import axios from "axios";
import { ALL_BUYER_DIALOG_FAIL, ALL_BUYER_DIALOG_REQUEST, ALL_BUYER_DIALOG_SUCCESS, ALL_REPORT_FAIL, ALL_REPORT_REQUEST, ALL_REPORT_SUCCESS, CDR_DETAILS_FAIL, CDR_DETAILS_REQUEST, CDR_DETAILS_RESET, CDR_DETAILS_SUCCESS, CDR_SIP_LOG_FAIL, CDR_SIP_LOG_REQUEST, CDR_SIP_LOG_RESET, CDR_SIP_LOG_SUCCESS, CREATE_ADMIN_BLOCK_REPORT_FAIL, CREATE_ADMIN_BLOCK_REPORT_REQUEST, CREATE_ADMIN_BLOCK_REPORT_SUCCESS } from "../constants/reportConstants";
import { toast } from "react-toastify";
import { api } from "../../mockData";

export const getReport = (filterValues, setLoader) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("admin"));
  try {
    dispatch({ type: ALL_REPORT_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token.access_token}`,
      },
    };

    const { data } = await axios.post(`${api.dev}/api/allcdr`, filterValues, config);

    if (data?.status === 200) {
      toast.success(data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
    } else {
      toast.error(data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
    }

    dispatch({ type: ALL_REPORT_SUCCESS, payload: data });
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2500,
    });
    dispatch({
      type: ALL_REPORT_FAIL,
      payload: error?.response?.data?.message,
    });
  } finally {
    setLoader(false); // This runs whether success or error
  }
};


  export const createBlockReport = (createBlockReport, setResp, setLoader, setSelectedRows) => async (dispatch) => {
 
    const token = JSON.parse(localStorage.getItem(`admin`));
            try {
              dispatch({ type: CREATE_ADMIN_BLOCK_REPORT_REQUEST });
              const config = {
                headers: {
                  "Content-Type": "application/json",
                  "Authorization" : `Bearer ${token.access_token} `
                },
              };
              const { data } = await axios.post(
                
                
                `${api.dev}/api/adminreportcallblock`,
                JSON.stringify(createBlockReport),
                config
              );
             if (data?.status === 200) {
                toast.success(data.data[0].message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setResp(data); 
                setSelectedRows([]);
                setLoader(false); 
              }  else {
                toast.error(data?.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 2500,
                });
              }
              dispatch({ type: CREATE_ADMIN_BLOCK_REPORT_SUCCESS, payload: data });
            } catch (error) {
              toast.error(error?.response?.data?.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2500,
              });
              dispatch({
                type: CREATE_ADMIN_BLOCK_REPORT_FAIL,
                payload: error?.response?.data?.message,
              });
            } finally {
              setLoader(false); // This runs whether success or error
            }
  };

  export const getBuyerDialog = (filterValues, setLoader) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("admin"));
  try {
    dispatch({ type: ALL_BUYER_DIALOG_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token.access_token}`,
      },
    };

    const { data } = await axios.post(`${api.dev}/api/buyerdiallog`, filterValues, config);

    if (data?.status === 200) {
      toast.success(data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
    } else {
      toast.error(data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
    }

    dispatch({ type: ALL_BUYER_DIALOG_SUCCESS, payload: data });
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2500,
    });
    dispatch({
      type: ALL_BUYER_DIALOG_FAIL,
      payload: error?.response?.data?.message,
    });
  } finally {
    setLoader(false); // This runs whether success or error
  }
};

export const getAdminCdrDetails = (uniqueid) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("admin"));
  try {
    dispatch({ type: CDR_DETAILS_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token?.access_token}`,
      },
    };
    const { data } = await axios.post(`${api.dev}/api/cdrdetails`, { uniqueid }, config);
    if (data?.status === 200) {
      dispatch({ type: CDR_DETAILS_SUCCESS, payload: data?.data });
    } else {
      dispatch({ type: CDR_DETAILS_FAIL, payload: data?.message });
      toast.error(data?.message || "Failed to load call details", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
    }
  } catch (error) {
    dispatch({
      type: CDR_DETAILS_FAIL,
      payload: error?.response?.data?.message,
    });
    toast.error(error?.response?.data?.message || "Failed to load call details", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2500,
    });
  }
};

export const resetAdminCdrDetails = () => (dispatch) => {
  dispatch({ type: CDR_DETAILS_RESET });
  dispatch({ type: CDR_SIP_LOG_RESET });
};

export const getAdminCdrSipLog = (uniqueid) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("admin"));
  try {
    dispatch({ type: CDR_SIP_LOG_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token?.access_token}`,
      },
    };
    const { data } = await axios.post(`${api.dev}/api/cdrdetails/siplog`, { uniqueid }, config);
    if (data?.status === 200) {
      dispatch({ type: CDR_SIP_LOG_SUCCESS, payload: data?.data });
    } else {
      dispatch({ type: CDR_SIP_LOG_FAIL, payload: data?.message });
    }
  } catch (error) {
    dispatch({
      type: CDR_SIP_LOG_FAIL,
      payload: error?.response?.data?.message || "Failed to load SIP logs",
    });
  }
};

export const resetAdminCdrSipLog = () => (dispatch) => {
  dispatch({ type: CDR_SIP_LOG_RESET });
};
